import { Injectable, EventEmitter } from '@angular/core';
import { Http, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class CartService {
  cartChanged: EventEmitter<Object> = new EventEmitter();
  cartData = JSON.parse(window.localStorage.getItem('cartOrder'));
  itemAdded: EventEmitter<Object> = new EventEmitter();
  itemsCount: number;
  quantityChanged: EventEmitter<number> = new EventEmitter();

  constructor(public http: Http) {
    this.initItemsCount();
  }

  initItemsCount() {
    if(this.cartData) {
      this.itemsCount = this.cartData.total_quantity;
    } else {
      this.itemsCount = 0
    }
  }

  public saveCart(orderId: number, restaurantId: number, quantity: number, price: number) {
    let cartData = {
      order_id: orderId,
      restaurant_id: restaurantId,
      total_quantity: quantity,
      total_price: price
    };
    window.localStorage.setItem('cartOrder', JSON.stringify(cartData));
    this.cartChanged.emit(cartData);
  }

  addItem(item: Object) {
    this.itemAdded.emit(item);
  }

  changeQuantity(quantity: number) {
    this.itemsCount = quantity;
    this.quantityChanged.emit(this.itemsCount);
  }
}



// WEBPACK FOOTER //
// ./src/providers/cart.ts